<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item v-for="item in menuList"
                      v-if="(item.menuurl=='StoreDetailListSupply'&&isZongBu()&&financeright)||(item.menuurl!='StoreDetailListSupply')"
                      :key="item.menuurl" :index="item.menuurl">{{item.menuname}}
        </el-menu-item>
        <el-menu-item index="810" v-if="isZongBu()&&financeright&&!UGO">审核采购价
          <span class="badge" v-if="statusnumber810>0">{{statusnumber810}}</span>
        </el-menu-item>
        <!--<el-menu-item index="all" v-if="financeright">全部</el-menu-item>-->
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <router-view :roletype="'jiesuan'" :mystatus="status" @bindTip="bindTip" v-if="visible"
                   :shoudongcaigou="invoicesource"></router-view>
      <iframe width="100%" scrolling="Auto" :height="tableHeight(12)" frameborder="0" name="jiesuanframe" v-if="visibleframe"></iframe>
    </el-main>
  </div>
</template>
<script>
  import {countlist} from '@/api/set/csagreement';
  import {getMenu, checkModuleRight,isUGO} from '@/api/login'

  export default {
    data() {
      return {
        activeIndex: "",
        statuseslist: "700;810;",
        status: "",
        invoicesource: '',//手动采购  1未审核 2审核通过
        visible: true,
        visibleframe:false,
        searchContentHeight: 50,
        statusnumber700: 0,
        statusnumber810: 0,
        userInfoModel: [],
        financeright: false,//拥有财务权限
        menuList: [],//菜单
        UGO:false,
      };
    },
    methods: {
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      handleSelect(key) {
        this.status = key
        if (key == '810') {
          this.invoicesource = 1
        }
        this.visible = false
        this.visibleframe = false;
        if (key.startsWith("frame:")) {
          this.visibleframe = true;
        }
        this.$nextTick(() => {
          if (key == "700" || key == "750" || key == "all" || key == '810') {
            this.$router.push({name: "CstagreementList"})
            this.visible = true
          } else {
            if (key.startsWith("frame:")) {
              window.open('//'+window.location.host + key.replace("frame:", ""), 'jiesuanframe', false);
            } else {
              this.$router.push({name: key})
              this.visible = true
            }
          }
        })
      },
      bindTip() {
        this.statusnumber700 = 0
        this.statusnumber810 = 0
      },
      getMenuList() {
        getMenu({
          MenuCode: this.$route.params.menucode,
          AppGuid: (localStorage.getItem("appguid") || "")
        }).then(response => {
          this.menuList = response.data.menu
          var routn=this.menuList[0].menuurl
          this.activeIndex=routn;
          this.handleSelect(routn);
        }).catch((error) => {
          console.log(error)
        });
      }
    },
    mounted() {
      this.UGO=isUGO();
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.financeright = this.$checkRight("财务")
      this.getMenuList()
    },
    components: {}
  }
</script>
<style scoped>

  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }

  .el-submenu__title, .el-submenu {
    height: 48px !important;
    line-height: 48px !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/account/JieSuan.vue